import { HttpParams } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Entry } from 'contentful';
import { KnownIssuesPage } from 'src/app/model/shared/known-issues-page';
import { ApiService } from 'src/app/service/api.service';
import { entraAuthService } from 'src/app/service/auth.service';
import { ContentfulService } from 'src/app/service/contentful.service';
import { SharedDataService } from 'src/app/service/shared-data.service';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';
import { config } from 'src/environments/environment';

@Component({
  selector: 'app-known-issues-content',
  templateUrl: './known-issues-content.component.html',
  styleUrls: ['./known-issues-content.component.scss']
})
export class KnownIssuesContentComponent implements OnInit {
  @Input() pageTitle: string = '';
  @Input() href: string = '';
  @Input() subscribeUrl: string = '';
  isUserLoggedIn = false;
  productUpdateSubscribed = false;
  KnownIssuesPage: KnownIssuesPage = {} as KnownIssuesPage;

  constructor(private contentfulService: ContentfulService, private sharedDataService: SharedDataService, private entraAuthService: entraAuthService, private apiService: ApiService, private router: Router) {}

  setPageTitle(pageTitle: string) {
    if (pageTitle.length > 0) {
      this.pageTitle = pageTitle;
    }
    this.ngOnInit();
  }

  ngOnInit(): void {
    htmlTitle.filter((title) => {
      if (title.page === 'known-issues') {
        this.KnownIssuesPage.htmlTitle = title.htmlTitle;
      }
    });
    const query = { 'fields.title': this.pageTitle };

    this.contentfulService.getPageContentResponse(query).then((knownIssuesPage) => {
      this.KnownIssuesPage.sections = [];
      this.KnownIssuesPage.tableSections = [];
      this.mapPageInfo(knownIssuesPage.items);
      this.mapBanner(knownIssuesPage.includes.Entry);
      this.sharedDataService.addSharedData(this.KnownIssuesPage.banner);
      this.mapSection(knownIssuesPage.includes.Entry);
      this.mapTableSection(knownIssuesPage.includes.Entry);
    });
  }

  private mapPageInfo(items: Entry<any>[]) {
    items.forEach((item: any) => {
      this.KnownIssuesPage.htmlTitle = item.fields.htmlTitle;
    });
  }

  private mapBanner(knownIssuesPageEntries: Entry<any>[]) {
    knownIssuesPageEntries
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapEntryToBanner(entry: Entry<any>) {
    let image: any = entry.fields['image'];
    let video: any = entry.fields['video'];
    this.KnownIssuesPage.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: image.fields.file.url,
      video: video?.fields?.file?.url,
      url: entry.fields?.['url'] as string,
      lastUpdated: entry.fields?.['lastUpdated'] as string
    };
  }

  private mapSection(knownIssuesSectionsEntries: Entry<any>[]) {
    knownIssuesSectionsEntries
      .filter((entry) => ModelValidator.isSection(entry))
      .forEach((entry) => {
        this.mapEntryToSection(entry);
      });
  }

  private mapEntryToSection(entry: Entry<any>) {
    this.KnownIssuesPage.sections.push({
      title: entry.fields['title'] as string,
      order: entry.fields['order'] as number,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      subBody: entry.fields['subBody'] as string,
      heading: entry.fields['heading'] as string
    });
    this.KnownIssuesPage.sections.sort((a, b) => a.order - b.order);
  }

  private mapTableSection(knownIssuesTableSectionsEntries: Entry<any>[]) {
    knownIssuesTableSectionsEntries
      .filter((entry) => ModelValidator.isTableSection(entry))
      .filter((entry) => {
        this.mapEntryToTableSections(entry);
      });
  }

  private mapEntryToTableSections(entry: Entry<any>) {
    this.KnownIssuesPage.tableSections.push({
      title: entry.fields['title'] as string,
      order: entry.fields['order'] as number,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      subBody: entry.fields['subBody'] as string,
      table: entry.fields['table'] as string
    });
    this.KnownIssuesPage.tableSections.sort((a, b) => a.order - b.order);
  }

  redirectToLogin(): void {
    localStorage.setItem('redirect_url', '/profile');
    this.entraAuthService.initLogin();
  }

  async getUserInformation(userId: string) {
    let queryParams = new HttpParams();
    queryParams = queryParams.append('id', userId);
    await this.apiService.sendGetRequest('/user', queryParams);
  }
}
